import { configureStore } from "@reduxjs/toolkit";
// Import your slices here
import userReducer from "./user/userSlice";

export const store = configureStore({
  reducer: {
    user: userReducer, 
    
  },
});
